import { useNavigate } from "react-router-dom";

export default function PageBackButton({ label = "Back", fallback = "/home" }) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate(fallback);
  };

  return (
    <button
      type="button"
      onClick={handleBack}
      aria-label={label}
      className="mb-3 inline-flex items-center gap-2 rounded-xl px-1 py-1.5 text-sm font-semibold text-violet-700 transition hover:bg-violet-50"
    >
      <img src="/back-arrow.svg" alt="" className="h-5 w-5" aria-hidden="true" />
      <span>{label}</span>
    </button>
  );
}
